/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind('.popup-youtube, .popup-vimeo', {
	on: {
		done: (fancybox) => {
			fancybox.container.querySelector('.is-close-btn').focus();
			fancybox.container.querySelector('iframe').setAttribute('title', 'Play Video');
		},
	},
});

const strl_responsive_iframes = function () {
  const iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
  
  iframes.forEach(iframe => {
    const videoContainer = document.createElement('div');
    videoContainer.classList.add('video-container', 'active');
    iframe.parentNode.insertBefore(videoContainer, iframe);
    videoContainer.appendChild(iframe);
  });
};

strl_responsive_iframes();
